export default "__VITE_ASSET__32e1f1b6__"